export default "/images/vendor/flag-icon-css/flags/1x1/cx.svg?dda4107fd05b8081ae62bc9871ba1d9d";